export class UserUrls {

	public static DOWNLOAD_USERS = '/api/v1/user/downloadusers';

}
